import {
  Box,
  Button,
  FormGroup,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { apiErrorMessage } from "../../helper/apiError";
import { Formik, Form } from "formik";
import moment from "moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import {
  CreateFileService,
  CreateFolderService,
} from "../../Redux/service/FileManagerService";
import { GetFolderAction, GetFolderAndFilesByParentlistAction } from "../../Redux/action/FileManagerAction";
import CustomButton from "../../component/button/button";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontSize } from "../../component/theme/fontSize";
import { fontWeight } from "../../component/theme/fontWeight";
import { ThemeColor } from "../../component/theme/color";
import Previews from "../../component/dropzone/Mydropzone";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "94%", sm: 520, md: 560 },
  maxWidth: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 24px 60px rgba(16, 24, 40, 0.22)",
  p: { xs: 2.5, sm: 3 },
  outline: "none",
};
const validationSchema = Yup.object({
  message: Yup.string()
    // .required("Resend date is required")/
    .when("fileUrl", {
      is: (fileUrl) => !fileUrl,
      then: (schema) =>
        schema.test(
          "is-greater",
          "Either text or file is required to send to chat",
          function (value) {
            const { fileUrl } = this.parent;

            if (fileUrl !== "" && !value) {
              // console.log("no file")
              return false;
            }
            return true;
          }
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
  fileUrl: Yup.string().notRequired(),
});

export const CreateFileModal = ({ createFileModal, handleClose, folderId }) => {
  const disptach = useDispatch();

  return (
    <Modal
      open={createFileModal}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: 2.5,
          }}
        >
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W600}
            fontSize={fontSize.h3.large}
            color={ThemeColor.BLACK}
          >
            Create File
          </Typography>
          <IconButton
            size="small"
            onClick={() => handleClose()}
            sx={{ color: "#667085" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Formik
          initialValues={{
            name: "",
            file: [],
          }}
          // validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            //("FOLDER data:", values);
            values["folder"] = folderId;
            values["size"] = values?.file?.[0]?.size;
            values["type"] = values?.file?.[0]?.type;
            values["url"] = values?.file?.[0]?.url;
            delete values["file"];

            await CreateFileService(values)
              .then((res) => {
                if (res.status === 200) {
                  // //(res);
                  if (folderId) disptach(GetFolderAndFilesByParentlistAction(folderId));
                  else disptach(GetFolderAction());
                  handleClose();

                  disptach(showSnackbar(res.data.message, "success"));
                  // navigate("/CAE/Filemanager");
                  resetForm();
                }
              })
              .catch((e) => {
                disptach(showSnackbar(apiErrorMessage(e), "error"));
              });
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().required("Name of file is must to create..."),
            file: Yup.array().min(1, "Select one file to create file"),
          })}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form className="w-100">
              <FormGroup>
                <OutlinedInputField
                  value={values.name}
                  name={"name"}
                  onChange={handleChange}
                  placeholder="File Name...."
                  fullWidth={true}
                  helperText={
                    <Typography
                      align="left"
                      color={ThemeColor.RED}
                      fontSize={fontSize.h4.medium}
                      fontFamily={FontFamily.Lato}
                      fontWeight={fontWeight.W500}
                    >
                      {errors.name}
                    </Typography>
                  }
                />
              </FormGroup>

              <FormGroup sx={{ mt: 2 }}>
                <Box sx={{ width: "100%" }}>
                  <Previews
                    height="25px"
                    deleteShow={true}
                    initialValue={values?.file}
                    handleMydropzoneFile={(updatedFiles) => {
                      setFieldValue("file", updatedFiles);
                    }}
                    helperText={
                      <Typography
                        align="left"
                        color={ThemeColor.RED}
                        fontSize={fontSize.h4.medium}
                        fontFamily={FontFamily.Lato}
                        fontWeight={fontWeight.W500}
                      >
                        {errors.file}
                      </Typography>
                    }
                  />
                </Box>
              </FormGroup>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row" },
                  justifyContent: "flex-end",
                  gap: 1.5,
                  mt: 3,
                  "& .MuiButton-root": {
                    width: { xs: "100%", sm: "auto" },
                  },
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => handleClose()}
                  sx={{
                    textTransform: "none",
                    borderRadius: "10px",
                    color: "#667085",
                    borderColor: "#d0d5dd",
                    "&:hover": {
                      borderColor: "#98a2b3",
                      backgroundColor: "#f9fafb",
                    },
                  }}
                >
                  Cancel
                </Button>
                <CustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  color={ThemeColor.WHITE}
                >
                  Create
                </CustomButton>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};
